import React, { useEffect, useRef, useContext } from 'react';
import * as d3 from 'd3';
import * as S from './BarChart.style';
import { ThemeContext } from 'styled-components';

export const BarChart = ({
  data,
  size,
}: {
  data: number[];
  size: { width: number; height: number };
}) => {
  const theme = useContext(ThemeContext);

  const chartRef = useRef<HTMLDivElement>(null);

  const drawChart = (
    node: React.RefObject<HTMLDivElement | null>,
    size: { width: number; height: number },
  ) => {
    if (!theme) return;

    // Guard: Don't draw if size is invalid
    if (!size.width || !size.height || size.width <= 0 || size.height <= 0) {
      return;
    }

    const set = data.map((p) => (p > 100 || p < 0 ? 0 : p));

    d3.select('#barchart').selectAll('svg').remove();

    const svg = d3
      .select(node.current)
      .append('svg')
      .attr('width', size.width)
      .attr('height', size.height)
      .style('border', `5px solid ${theme.primary}`);

    svg
      .selectAll('rect')
      .data(set)
      .enter()
      .append('rect')
      .attr('x', (d, i) => {
        return i * (size.width / 2);
      })
      .attr('y', (d) => {
        return size.height - d;
      })
      .attr('width', size.width / 2 - 10)
      .attr('height', (d) => d)
      .attr('fill', theme.primary);

    svg
      .selectAll('text')
      .data(data)
      .enter()
      .append('text')
      .attr('x', (dataPoint, i) => i * (size.width / 2) + size.width / 4.9)
      .attr('y', (dataPoint) => size.height - dataPoint * 0.5)
      .attr('fill', theme.accent)
      .text((dataPoint) => Math.round(dataPoint));
  };
  useEffect(() => {
    if (!data.length) return;

    drawChart(chartRef, size);
  }, [data, size, theme]);

  return (
    <S.ChartSpace>
      <div ref={chartRef} id="barchart"></div>
    </S.ChartSpace>
  );
};
